import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductRefundDocument.Find.IRequest;
type Response = Api.Core.ProductRefundDocument.Find.IResponse;
type Headers = Api.Core.ProductRefundDocument.Find.IHeaders;
const url = '/api/ProductManagement/ProductRefundDocument/:documentId';
export default async function productRefundDocumentFindApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, body),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
